import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import ShowMoreText from 'react-show-more-text'

import { usePreviewContext } from 'context/previewContext'
import { renderPostText } from 'helpers/postHelpers'
import { someTimeAgo, someTimeAgoPosts } from 'lib/dayjs'
import { type IPostTag } from 'types/interfaces/ITypes'

import './_showMore.scss'
import './ShowMoreText.css'

interface Props {
  userId?: string
  username?: string
  customClass?: string
  name: string
  time: string | Date
  tags?: string[]
  text: string
  mentions: IPostTag[]
  onClose?: () => void
  sponsored_post?: boolean
}

export const ShowMore = ({
  customClass,
  name,
  time,
  text,
  mentions,
  username,
  onClose,
  sponsored_post
}: Props) => {
  const [expanded, setExpanded] = useState(false)
  const [useAltTime, setUseAltTime] = useState(false)

  const { t } = useTranslation()

  const handleOnClick = () => setExpanded((prev) => !prev)

  const toggleTime = () => setUseAltTime((prev) => !prev)

  const formattedTime = useAltTime
    ? someTimeAgo(time)
    : someTimeAgoPosts(time)

  return (
    <div className={`showMore showMore--${customClass ?? ''}`}>
      <div className="showMore__wrapper">
        <div className="showMore__title">
        {sponsored_post ? (
          <div className="showMore__title--name">
            <span className="showMore__title--displayName">{name}</span>
            <span className="showMore__title--username">@{username}</span>
          </div>
        ) : (
          <Link
            to={`/${username}/`}
            className="showMore__title--name"
            onClick={() => onClose?.()}
          >
            <span className="showMore__title--displayName">{name}</span>
            <span className="showMore__title--username">@{username}</span>
          </Link>
        )}
          <div
            className="showMore__title--time"
            onClick={toggleTime}
            style={{ cursor: 'pointer' }}
            title="Click to toggle time format"
          >
            {formattedTime}
          </div>
        </div>
        {!!text?.trim() && (
          <ShowMoreText
            lines={3}
            more={t('showMore')}
            less={t('showLess')}
            className="content-css"
            anchorClass="my-anchor-css-class"
            onClick={handleOnClick}
            expanded={expanded}
            truncatedEndingComponent=""
            keepNewLines={false}
            width={600}
          >
            {renderPostText(text, mentions)}
          </ShowMoreText>
        )}
      </div>
    </div>
  )
}
